import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HighchartsChartModule } from 'highcharts-angular';

import { CybersocxdrRoutingModule } from './cybersocxdr-routing.module';
import { AppSharedModule } from '../app-shared.module';
import { CybersocxdrDashboardComponent } from './cybersocxdrdashboard/cybersocxdrdashboard.component';
import { CybersocxdrSLAComponent } from './cybersocxdrsla/cybersocxdrsla.component';
import { CybersocxdrContactComponent } from './cybersocxdrcontact/cybersocxdrcontact.component';
import { CybersocxdrMenuComponent } from './cybersocxdrmenu/cybersocxdrmenu.component';
import { CybersocxdrIncidentBySeverityComponent } from './charts/incidentbyseverity/incidentbyseverity.component';
import { CybersocxdrIncidentBySeverityCategoryComponent } from './charts/incidentbyseveritycategory/incidentbyseveritycategory.component';
import { BarovertimeComponent } from './charts/barovertime/barovertime.component';
import { AreaovertimeComponent } from './charts/areaovertime/areaovertime.component';
import { PackedbubblehostComponent } from './charts/packedbubblehost/packedbubblehost.component';
import { SlaGaugeComponent } from './charts/slagauge/slagauge.component';
import { PieComponent } from './charts/pie/pie.component';
import { SecurityNavigatorComponent } from './charts/securitynavigator/securitynavigator.component';
import { SladetailsComponent } from './components/sladetails/sladetails.component';
import { IncidentformComponent } from './components/incidentform/incidentform.component';
import { SecuritynavigatormanagerComponent } from './components/securitynavigatormanager/securitynavigatormanager.component';
import { TranslateModule } from '@ngx-translate/core';
import { IncidentlistComponent } from './components/incidentlist/incidentlist.component';
import { ScatterpyramidComponent } from './charts/scatterpyramid/scatterpyramid.component';
import { CybersocxdrIncidentsComponent } from './cybersocxdrincidents/cybersocxdrincidents.component';
import { CybersocXdrIncidentDetailsComponent } from './cybersocxdrincidentdetails/cybersocxdrincidentdetails.component';
import { IncidentTimelineComponent } from './charts/incident-timeline/incident-timeline.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { WorldmapComponent } from './charts/worldmap/worldmap.component';
import { SunburstComponent } from './charts/sunburst/sunburst.component';
import { PolarComponent } from './charts/polar/polar.component';
import { CybersocxdrcomopgenComponent } from './cybersocxdrcomopgen/cybersocxdrcomopgen.component';
import { FiltermenuComponent } from './components/filtermenu/filtermenu.component';
import { TableComponent } from './charts/table/table.component';
import { SearchabledropdownComponent } from './components/searchabledropdown/searchabledropdown.component';
import { CybersocxdrglobalfiltersService } from './cybersocxdrglobalfilters.service';
import { AnonymisePipe } from './pipes/anonymise.pipe';
import { MicrosocCaseListComponent } from './components/microsocCase-list/microsocCase-list.component';
import { XtendedSOC4A3WComponent } from './cybersocxdr4A3W/xtendedsoc4A3W.component';
import { XtendedChartService } from '../shared/services/xtendedsoc/xtended-chart.service';
import { SankeyComponent } from './charts/sankey/sankey.component';

@NgModule({
  declarations: [
    CybersocxdrDashboardComponent,
    CybersocxdrSLAComponent,
    CybersocxdrContactComponent,
    CybersocxdrMenuComponent,
    CybersocxdrIncidentBySeverityComponent,
    CybersocxdrIncidentBySeverityCategoryComponent,
    BarovertimeComponent,
    AreaovertimeComponent,
    SlaGaugeComponent,
    PieComponent,
    SankeyComponent,
    PackedbubblehostComponent,
    SecurityNavigatorComponent,
    SladetailsComponent,
    IncidentformComponent,
    SecuritynavigatormanagerComponent,
    IncidentlistComponent,
    ScatterpyramidComponent,
    CybersocxdrIncidentsComponent,
    CybersocXdrIncidentDetailsComponent,
    IncidentTimelineComponent,
    WorldmapComponent,
    SunburstComponent,
    PolarComponent,
    CybersocxdrcomopgenComponent,
    FiltermenuComponent,
    TableComponent,
    SearchabledropdownComponent,
    AnonymisePipe,
    MicrosocCaseListComponent,
    XtendedSOC4A3WComponent,
  ],
  imports: [
    CommonModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    CybersocxdrRoutingModule,
    AppSharedModule,
    HighchartsChartModule,
    TranslateModule,
    InfiniteScrollModule,
  ],
  exports: [CybersocxdrDashboardComponent, CybersocxdrSLAComponent, CybersocxdrContactComponent],
  bootstrap: [CybersocxdrDashboardComponent, CybersocxdrSLAComponent, CybersocxdrContactComponent],
  providers: [CybersocxdrglobalfiltersService, XtendedChartService],
})
export class CybersocxdrModule {}
